function makeAgentList(list: any) {
  return list?.map((item: any) => {
    return {
      label: item.name,
      value: item.userId,
    };
  });
}

function makeTaskList(list: any) {
  return list?.map((item: any) => {
    return {
      label: item.formerTaskTypeName,
      value: {
        id: item.formerTaskId,
        type: item.formerTaskType,
        taskTitle: item.taskTitle,
        taskText: item.taskText,
        dueDate: item.dueDate,
      },
    };
  });
}

function makeFacilityList(list: any) {
  const listData = list?.map((item: any) => {
    return {
      label: `${item.facilityNo}:${item.facilityName}`,
      value: item.facilityNo,
    };
  });
  listData.push({
    label: "999:契約対象外施設",
    value: "999",
  });

  return listData;
}

export { makeAgentList, makeTaskList, makeFacilityList };
